import moment from 'moment';

/**
 * Normalizes lead data to ensure consistent structure
 */
export const normalizeLead = (lead) => {
  if (!lead) return null;
  
  return {
    ...lead,
    callCount: lead.callCount !== undefined ? Number(lead.callCount) : 0,
    tags: lead.tags || [],
    dateAdded: lead.dateAdded || lead.createdAt || new Date().toISOString(),
    // Ensure we have both _id and leadId for compatibility
    _id: lead._id || lead.leadId,
    leadId: lead.leadId || lead._id
  };
};

/**
 * Formats a date as a relative time from now
 */
export const formatRelativeTime = (dateString) => {
  if (!dateString) return 'No date';
  return moment(dateString).fromNow();
};

/**
 * Formats a date in a standard format
 */
export const formatDate = (dateString) => {
  if (!dateString) return '';
  return moment(dateString).format('MMM D, YYYY');
};

/**
 * Determines if a follow-up is overdue
 */
export const isFollowUpOverdue = (followUpTime) => {
  if (!followUpTime) return false;
  return moment(followUpTime).isBefore(moment());
};

/**
 * Gets the display name from a lead
 */
export const getLeadDisplayName = (lead) => {
  if (!lead) return 'Unknown';
  return lead.brideAndGroomName || lead.name || 'Unnamed Lead';
};
